@if (isNewPage) {
  <div class="row">
    <div class="col">
      <div class="edit-menu-item-icon">
        <span [ngClass]="iconClass"></span>
      </div>
      <span [innerText]="enteredName" style="white-space: pre;"></span>
    </div>
  </div>
}

<form [formGroup]="addPageForm" class="edit-menu-form" action="">
  <div class="form-group">
    <label for="name">
      <span translate>Page name</span>
      <scitis-required-field-indicator></scitis-required-field-indicator>
    </label>
    @if (checkTemplatePageName) {
      <span class="fa-solid fa-spinner fa-spin ml-2"></span>
    }
    <input [ngClass]="{ 'is-invalid': submitted && addPageForm.controls.name.errors }" class="form-control"
      formControlName="name" id="name" type="text" (focusout)="onUpdateName()">
      @if (submitted && addPageForm.controls.name.errors) {
        <div class="invalid-feedback">
          @if (addPageForm.controls.name.errors.required) {
            <span translate>Page name required</span>
          }
        </div>
      }
      @if (pageNameIsNotUniqueOnMachine) {
        <div class="text-danger">
          <span translate>This page name already exists on this machine!</span>
        </div>
      }
      @if (templatePageNameIsNotUniqueAcrossAllMachines) {
        <div class="text-danger">
          <span translate>This template page name already exists for the machine tag and category of this machine!</span>
        </div>
      }

    </div>
    <div class="form-group">
      <label for="type">
        <span translate>Page type</span>
        <scitis-required-field-indicator></scitis-required-field-indicator>
      </label>
      <ng-select [clearable]="false"
        [ngClass]="{ 'is-invalid': submitted && addPageForm.controls.type.errors }"
        [searchable]="false"
        (change)="onTypeChange($event)"
        appearance="outline"
        formControlName="type"
        id="type" labelForId="type"
        [placeholder]="'Select page type ...' | translate">
        @for (pageTypeOption of pageTypeOptions; track pageTypeOption) {
          <ng-option [value]="pageTypeOption.value" [disabled]="isDisabledOption(pageTypeOption)">
            <div>
              <span [ngClass]="pageTypeOption.icon" class="fa mr-1"></span>
              <span [title]="getTitle(pageTypeOption)" [innerText]="pageTypeOption.label | translate"></span>
            </div>
          </ng-option>
        }
      </ng-select>
      @if (submitted && addPageForm.controls.type.errors) {
        <div class="invalid-feedback">
          @if (addPageForm.controls.type.errors.required) {
            <span translate>Page type required</span>
          }
        </div>
      }
    </div>
    @if (showUrlField) {
      <div class="form-group">
        <label for="url">
          <span translate>Url</span>
          <scitis-required-field-indicator></scitis-required-field-indicator>
        </label>
        @if (loadUrl) {
          <span class="fa-solid fa-spinner fa-spin ml-2"></span>
        }
        <input [ngClass]="{ 'is-invalid': addPageForm.controls.url.errors }" class="form-control"
          formControlName="url" id="url" type="url">
          @if (addPageForm.controls.url.errors) {
            <div class="invalid-feedback">
              @if (submitted && addPageForm.controls.url.errors.required) {
                <span translate>Url required</span>
              }
              @if (addPageForm.controls.url.errors.pattern) {
                <span class="help-block" translate>Url invalid. It should start with http:// or https://</span>
              }
            </div>
          }
        </div>
      }
      @if (isFramePage) {
        <div class="alert alert-info" role="alert">
          <span [innerHtml]="framePageHelp"></span>&nbsp;
          <a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Frame-Options" target="_blank" translate>Learn more</a>
        </div>
      }

      <div class="d-flex">
        <button type="button" (click)="onSaveNewPage()" [disabled]="isSavePageButtonDisabled || pageNameIsNotUniqueOnMachine || templatePageNameIsNotUniqueAcrossAllMachines" class="btn btn-primary">
          <span translate>Save page</span>
        </button>
        <button type="button" (click)="onCancelSavePage()" class="btn btn-link" translate>Cancel</button>
      </div>
    </form>
